import { Capacitor } from '@capacitor/core';

export async function openExternalLink(url) {
  if (!url || url === '#') {
    console.warn('⚠️ Invalid URL:', url);
    return;
  }

  if (Capacitor.isNativePlatform()) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      console.log('🌐 Opened in native browser:', url);
    } catch (error) {
      console.error('❌ Failed to open in native browser:', error);
      window.open(url, '_blank');
    }
  } else {
    window.open(url, '_blank');
  }
}
